<script>
    import ApexCharts from 'apexcharts'
    import { onMount, onDestroy } from 'svelte'
    import { statisticsStore } from '../../stores/Statistics'
    import { t } from 'totalinvoice-frontend-core'

    let container
    let chart

    const options = {
        chart: {
            type: 'bar',
            height: 380,
            width: '100%',
            stacked: true,
            toolbar: {
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false
                }
            }
        },
        /*plotOptions: {
            bar: {
                columnWidth: '45%',
            }
        },*/
        colors: ['#00D8B6', '#FF4560'],
        series: [],
        xaxis: {
            type: 'datetime',
            labels: {
                show: false,
            },
            axisBorder: {
                show: false
            },
            tickAmount: 1,
            axisTicks: {
                show: false
            },
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
            labels: {
                style: {
                    colors: '#78909c'
                }
            },
        },
        tooltip: {
            x: {
                format: "MMM 'yy"
            }
        },
        title: {
            text: $t('Monthly Invoices'),
            align: 'left',
            style: {
                fontSize: '18px'
            }
        },
        noData: {
            text: $t('Loading...'),
        }
    }

    let initialized = false
    let rendered = false

    onMount(() => {
        chart = new ApexCharts(container, options)
        chart.render().then(() => {
            initialized = true
        })
    })

    onDestroy(() => {
        chart.destroy()
    })

    $: if (initialized === true && rendered === false && $statisticsStore.requestsByMonth.finished.data) {
        let finishedSeries = $statisticsStore.requestsByMonth.finished
        let failedSeries = $statisticsStore.requestsByMonth.failed

        // only show data of the last 12 months
        finishedSeries = finishedSeries.data.slice(Math.max(finishedSeries.data.length - 12, 0))
        failedSeries = failedSeries.data.slice(Math.max(failedSeries.data.length - 12, 0))

        chart.updateSeries([{
            name: $t('Success'),
            data: finishedSeries,
        }, {
            name: $t('Failure'),
            data: failedSeries,
        }])

        rendered = true
    }
</script>

<div bind:this={container} />
